import { GsFormSchema } from '../../../components';
import { BASIC_SCHEMA_FIELDS } from '../basics';

export const ARTICLE_INFO_TICKET_SLIDE_COMPONENT_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    {
      formControlName: 'orientation',
      label: 'gallerySlideComponents.articleInfoTicket.schema.orientation.label',
      description: 'gallerySlideComponents.articleInfoTicket.schema.orientation.description',
      type: 'select',
      valueType: 'string',
      default: 'portrait',
      options: [
        { text: 'gallerySlideComponents.articleInfoTicket.schema.orientation.portrait', value: 'portrait' },
        { text: 'gallerySlideComponents.articleInfoTicket.schema.orientation.landscape', value: 'landscape' }
      ]
    },
    {
      formControlName: 'showHeader',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showHeader.label',
      description: 'gallerySlideComponents.articleInfoTicket.schema.showHeader.description',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'headline',
      label: 'gallerySlideComponents.articleInfoTicket.schema.headline.label',
      placeholder: 'gallerySlideComponents.articleInfoTicket.schema.headline.placeholder',
      type: 'text',
      nullable: true,
      if: { args: [{ formControlName: 'showHeader', value: true }] }
    },
    {
      formControlName: 'showImage',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showImage.label',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showBadges',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showBadges.label',
      description: 'gallerySlideComponents.articleInfoTicket.schema.showBadges.description',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showDescription',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showDescription.label',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showRegistrationCard',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showRegistrationCard.label',
      description: 'gallerySlideComponents.articleInfoTicket.schema.showRegistrationCard.description',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showLogo',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showLogo.label',
      type: 'checkbox',
      default: true,
      if: { args: [{ formControlName: 'showRegistrationCard', value: true }] }
    },
    {
      // Kein Benutzer-Setting: sorgt nur dafuer, dass das Flag mit dem Struct ans Backend geht,
      // damit der Render den QR-Code der Veranstaltungsseite mitliefert.
      formControlName: 'generateDetailLinkQRCode',
      type: 'control',
      default: true
    },
    {
      formControlName: 'showOpeningTimes',
      label: 'gallerySlideComponents.articleInfoTicket.schema.showOpeningTimes.label',
      type: 'checkbox',
      default: true
    }
  ]
};
